import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { I18nProvider } from "@/i18n/I18nProvider";

export default function Layout() {
  const [openSignal, setOpenSignal] = useState(0);

  return (
    <I18nProvider>
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer onOpenCookies={() => setOpenSignal((n) => n + 1)} />
        <CookieBanner openSignal={openSignal} />
      </div>
    </I18nProvider>
  );
}
